import Box, { type BoxProps } from '@liquidweb-dev/undercurrent/Box';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

export interface FadeCollapseProps extends BoxProps {
	in: boolean;
	/** in milliseconds */
	collapseTimeout?: number;
	/** in milliseconds */
	fadeTimeout?: number;
}

const FadeCollapse = ({
	children,
	in: inProp,
	collapseTimeout = 400,
	fadeTimeout = 100,
	sx,
	...rest
}: FadeCollapseProps) => (
	<Box
		sx={combineSx(
			{
				display: 'grid',
				gridTemplateRows: inProp ? '1fr' : '0fr',
				opacity: inProp ? 1 : 0,
				transition: `grid-template-rows ${collapseTimeout}ms ease-in-out, opacity ${fadeTimeout}ms ease-in-out`,
				overflow: 'hidden',
			},
			sx,
		)}
		{...rest}
	>
		<Box
			sx={{
				minHeight: '0',
				visibility: inProp ? 'visible' : 'hidden',
				transition: `visibility ${collapseTimeout}ms ease-in-out`,
			}}
		>
			{children}
		</Box>
	</Box>
);

export default FadeCollapse;
